import { createRouter } from '../Router.mjs';

const { RouterProvider: MemberManagementRouterProvider, Router: MemberManagementRouter, useRouterController: useMemberManagementRouterController} = createRouter();

export { MemberManagementRouter, MemberManagementRouterProvider, useMemberManagementRouterController };
//# sourceMappingURL=MemberManagementRouter.mjs.map
